'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n  align-items: ', ';\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: ', ';\n  margin-left: -', ';\n  margin-top: -', ';\n\n  /* this makes the responsive scenario work */\n  @media only screen and (max-width: ', ') {\n    flex-grow: 1;\n  }\n\n  &&& > * {\n    margin-left: ', ';\n    margin-top: ', ';\n  }\n\n  /* nested containers zero-out margins */\n  &&& {\n    ', ';\n  }\n'], ['\n  align-items: ', ';\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: ', ';\n  margin-left: -', ';\n  margin-top: -', ';\n\n  /* this makes the responsive scenario work */\n  @media only screen and (max-width: ', ') {\n    flex-grow: 1;\n  }\n\n  &&& > * {\n    margin-left: ', ';\n    margin-top: ', ';\n  }\n\n  /* nested containers zero-out margins */\n  &&& {\n    ', ';\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  ', ';\n'], ['\n  ', ';\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Style = require('../core/Style');

var _sizes = require('HubStyleTokens/sizes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ALIGN_OPTIONS = {
  baseline: 'baseline',
  center: 'center',
  start: 'flex-start',
  end: 'flex-end',
  stretch: 'stretch'
};

var JUSTIFY_OPTIONS = {
  between: 'space-between',
  center: 'center',
  end: 'flex-end',
  start: 'flex-start'
};

var getFlexWrapper = function getFlexWrapper() {
  return (0, _styledComponents.css)(_templateObject, function (props) {
    return ALIGN_OPTIONS[props.alignItems];
  }, function (props) {
    return JUSTIFY_OPTIONS[props.justify];
  }, function (props) {
    return (0, _Style.remCalc)(props.horizontalGap);
  }, function (props) {
    return (0, _Style.remCalc)(props.verticalGap);
  }, (0, _Style.remCalc)(_sizes.GRID_BREAKPOINT_SMALL, 'em'), function (props) {
    return (0, _Style.remCalc)(props.horizontalGap);
  }, function (props) {
    return (0, _Style.remCalc)(props.verticalGap);
  }, function (props) {
    return props.nested && '\n        margin-left: 0;\n        margin-top: 0;\n      ';
  });
};

var Wrapper = _styledComponents2.default.div.withConfig({
  displayName: 'UIButtonWrapper__Wrapper'
})(_templateObject2, function (props) {
  return props.layout === 'default' && getFlexWrapper;
});

var UIButtonWrapper = function UIButtonWrapper(props) {
  var alignItems = props.alignItems,
      className = props.className,
      children = props.children,
      justify = props.justify,
      layout = props.layout,
      nested = props.nested,
      rest = _objectWithoutProperties(props, ['alignItems', 'className', 'children', 'justify', 'layout', 'nested']);

  return _react2.default.createElement(
    Wrapper,
    _extends({
      alignItems: alignItems,
      className: className,
      justify: justify,
      layout: layout,
      nested: nested
    }, rest),
    children
  );
};

UIButtonWrapper.propTypes = {
  alignItems: _react.PropTypes.oneOf(Object.keys(ALIGN_OPTIONS)),
  children: _react.PropTypes.node,
  className: _react.PropTypes.string,
  justify: _react.PropTypes.oneOf(Object.keys(JUSTIFY_OPTIONS)),
  horizontalGap: _react.PropTypes.number,
  layout: _react.PropTypes.oneOf(['default', 'legacy']),
  nested: _react.PropTypes.bool,
  verticalGap: _react.PropTypes.number
};

UIButtonWrapper.defaultProps = {
  alignItems: 'center',
  horizontalGap: parseInt(_sizes.BASE_SPACING_X, 10),
  layout: 'default',
  verticalGap: parseInt(_sizes.BASE_SPACING_Y, 10)
};

UIButtonWrapper.displayName = 'UIButtonWrapper';

exports.default = UIButtonWrapper;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1115/js/layout/UIButtonWrapper.js
// module id = 325
// module chunks = 0